<ss-building-block-notification-banner
  [banner]="notificationBannerForRoute()"
  (closeBanner)="closeNotificationBanner()"
/>
